'use client';

import type { ChartScale, MetricId, PizzaModelId } from '@/lib/types';

type Props = {
  metric: MetricId;
  onMetricChange: (v: MetricId) => void;
  scale: ChartScale;
  onScaleChange: (v: ChartScale) => void;
  pizzaModel: PizzaModelId;
  onPizzaModelChange: (v: PizzaModelId) => void;
};

export function ChartControls({
  metric,
  onMetricChange,
  scale,
  onScaleChange,
  pizzaModel,
  onPizzaModelChange,
}: Props) {
  return (
    <div className="controls" role="group" aria-label="Chart controls">
      <label>
        Metric
        <select value={metric} onChange={(e) => onMetricChange(e.target.value as MetricId)}>
          <option value="pizzas_per_btc">Pizzas per BTC</option>
          <option value="btc_per_pizza">BTC per pizza</option>
          <option value="pizzas_for_10000_btc">Pizzas for 10,000 BTC</option>
        </select>
      </label>

      <label>
        Scale
        <select value={scale} onChange={(e) => onScaleChange(e.target.value as ChartScale)}>
          <option value="linear">Linear</option>
          <option value="log">Log</option>
        </select>
      </label>

      <label>
        Pizza model
        <select value={pizzaModel} onChange={(e) => onPizzaModelChange(e.target.value as PizzaModelId)}>
          <option value="yearly_schedule_usd">Yearly schedule (inflation-adjusted)</option>
          <option value="constant_20_usd">Laszlo baseline ($20)</option>
        </select>
      </label>
    </div>
  );
}
